export const projectsData = [
    {
        title: "Software Requiremnet Bot",
        category: "Web Application",
        image: "/projects/sre.png",
        technologies: ["React", "Node.js", "PostgreSQL", "Gemini", "OpenAI", 'SMTP'],
        description:
            "Our intelligent bot helps you capture, organize, and refine software requirements through natural conversation. Say goodbye to missed requirements.",
        gradient: "from-[#e3b15a] to-[#f5d58a]",
        link: "https://sre-project.vercel.app/",
        isFeatured: true,
    },
    {
        title: "BlogSyte",
        category: "Web Application",
        image: "/projects/blogSyte.PNG",
        technologies: ["React", "Node.js", "PostgreSQL", "SMTP"],
        description:
            "BlogSyte is a content-focused platform designed to help writers, creators, and readers connect through engaging and well-structured blog posts. It offers a simple yet modern interface for reading, writing, and sharing articles on various topics.",
        gradient: "from-[#e93d3d] to-[#ff7f7f]",
        link: "https://blogsyte.vercel.app/",
        isFeatured: true,
    },
    {
        title: "IQify",
        category: "Web Application",
        image: "/projects/Iqify.jpeg",
        technologies: ["HTML", "CSS", "javascript", "localStorage"],
        description:
            "IQify is an interactive IQ test website designed for users to assess their intelligence through a series of questions. It instantly provides results with a certificate and consists of three main pages: Home, TestPage, and ResultPage, showcasing my web development skills.",
        gradient: "from-[#efb921] to-[#ffd75e]",
        link: "https://ahmedammad1709.github.io/IQify-Website/",
        isFeatured: true,
    },
    {
        title: "AI Student Assistant",
        category: "Desktop App",
        image: "/projects/aistudentassistant1.png",
        technologies: ["Java", "OOP", "File Handling", "SQLite"],
        description:
            "application built in Java using OOP principles and database integration. It features a dynamic login/signup system, password recovery, and a Gemini AI-powered dashboard that answers student queries. This project demonstrates advanced Java concepts, file handling, and API integration.",
        gradient: "from-[#71a5f8] to-[#a8c9fb]",
        link: "https://github.com/ahmedammad1709/aistudentassistant",
        isFeatured: true,
    },
    {
        title: "Codeveil Studio",
        category: "Full Stack App",
        image: "/projects/codeveil.png",
        technologies: ["React", "Node.js", "Tailwind CSS", "vite"],
        description:
            "Codeveil Studio is a professional service-based portfolio website showcasing creative and tech-based solutions including Web & App Development, Game Design, AI Chatbot Integration, and Graphic Design.",
        gradient: "from-[#3ba755] to-[#9be15d]",
        link: "https://codeveilstudio.vercel.app/",
        isFeatured: true,
    },
    {
        title: "Gen Craft ",
        category: "AI Powered Website",
        image: "/projects/iqify.png",
        technologies: ["React", "Node.js", "Gemini"],
        description:
            "GenCraft is an all-in-one AI-powered platform designed to simplify daily tasks with cutting-edge artificial intelligence. Deployed via Vercel, it integrates multiple AI services under a single, smooth, and responsive UI.",
        gradient: "from-[#71a5f8] to-[#a8c9fb]",
        link: "https://gencraft.vercel.app/",
        isFeatured: true,
    },
    {
        title: "SmartCal",
        category: "Web App",
        image: "/projects/smartCal.PNG",
        technologies: ["HTML", "CSS", "Javascript", "Python", "Sqlite"],
        description:
            "SmartCal is a powerful full-stack web application developed as a client project during my time at Potentials Dev+. It streamlines agenda and meeting management with features for individuals, teams, and administrators. Users can schedule in-person or virtual meetings, manage teams, and integrate their Google Calendar for seamless workflows.📅 Designed for professionals, teams, and organizations looking for smart scheduling and collaboration tools.",
        gradient: "from-[#71a5f8] to-[#a8c9fb]",
        link: "",
        isFeatured: false,
    },
    {
        title: "Flappy Boss",
        category: "Game",
        image: "/projects/flappyBoss.PNG",
        technologies: ["Unity", "C#", "2D Animations"],
        description:
            "Flappy Boss is a fun, addictive, and polished arcade-style game inspired by the classic Flappy Bird — but with a modern twist! Featuring dynamic UI, animated characters, and a top 5 leaderboard system, the game offers players a competitive yet entertaining experience across multiple platforms, both downloadable and playable online🎮 Available for PC, Android, and Web — Play anywhere, anytime!.",
        gradient: "from-[#71a5f8] to-[#a8c9fb]",
        link: "https://ahmedammad1709.itch.io/flappyboss-online",
        isFeatured: false,
    },
    {
        title: "Haunted Horizons",
        category: "Game",
        image: "/projects/hauntedHorizons.PNG",
        technologies: ["Unity", "C#", "2D Animations"],
        description:
            "Haunted Horizons is a thrilling 2D platformer game developed in Unity using C#, where survival is everything. From dodging creepy creatures to chasing high scores, players are dropped into a spooky world full of random enemy spawns and intense platforming action.",
        gradient: "from-[#71a5f8] to-[#a8c9fb]",
        link: "https://ahmedammad1709.itch.io/hypersphere-for-web",
        isFeatured: false,
    },
    {
        title: "Hyper Sphere",
        category: "Game",
        image: "/projects/hyperSphere.PNG",
        technologies: ["Unity", "C#", "3D Animations"],
        description:
            "Hyper Sphere is an electrifying 3D endless runner that challenges players to navigate a perpetually rolling sphere through a series of dynamic obstacles and jumps. The game demands precision, quick reflexes, and strategic maneuvering to achieve high scores. With each level, the difficulty escalates, pushing players to continually hone their skills.",
        gradient: "from-[#71a5f8] to-[#a8c9fb]",
        link: "https://ahmedammad1709.itch.io/hypersphere-for-web",
        isFeatured: false,
    },
];
